/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */

import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import FocusTrap from "focus-trap-react";

// REDUX
import { connect } from "react-redux";
import * as elementsActions from "../../redux/actions/elements";

import CmsInlineEdit from "../Cms/CmsInlineEdit";
import styles from "./Modal.module.css";

const exitIcon = require("./imgs/exit-icon.svg");

const Modal = props => {
  const {
    exit,
    title,
    titleCMSNode,
    description,
    descriptionCMSNode,
    action1,
    action1Label,
    action2,
    action2Label,
    action3Label,
    action3,
    setModalObject,
    children,
    maxWidth,
    zIndex,
    cmsPreEdit,
    ariaLabelledBy,
    fullscreenChildren
  } = props;

  const fullscreenContainerRef = useRef(null);

  const closeModal = () => {
    if (action1) {
      action1();
      return;
    }
    setModalObject(null);
  };

  useEffect(() => {
    const container = fullscreenChildren
      ? fullscreenContainerRef.current
      : document.querySelector("#modal");

    if (!container) {
      return () => {};
    }

    container.setAttribute("tabindex", "-1");
    const preferredFocusTarget =
      container.querySelector('[data-modal-action="action2"]') ||
      container.querySelector('button:not([disabled])');

    if (preferredFocusTarget && preferredFocusTarget.focus) {
      preferredFocusTarget.focus();
    } else {
      container.focus();
    }

    return () => {};
  }, [fullscreenChildren]);

  const onModalClose = () => {
    closeModal();
  };

  if (fullscreenChildren) {
    if (!children) {
      return null;
    }

    return (
      <div
        className="fixed inset-0"
        style={{ zIndex }}
      >
        <FocusTrap
          focusTrapOptions={{
            initialFocus: () => {
              const container = fullscreenContainerRef.current;
              if (!container) {
                return document.body;
              }
              return (
                container.querySelector('button:not([disabled])') ||
                container.querySelector('[role="dialog"]') ||
                container
              );
            },
            fallbackFocus: () =>
              fullscreenContainerRef.current || document.body,
            clickOutsideDeactivates: false,
            escapeDeactivates: false
          }}
        >
          <div ref={fullscreenContainerRef}>{children}</div>
        </FocusTrap>
      </div>
    );
  }

  return (
    <div
      className={`${styles.modalWrapper} fixed inset-0 bg-opacity-25
    backdrop-blur-sm flex justify-center items-center
     shadow-[0_0_15px_6px_rgba(0,0,0,0.35)] bg-darkBlack`}
      style={{ zIndex }}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? "modal-title" : ariaLabelledBy || undefined}
      onKeyDown={e => {
        if (e.key === "Escape" || e.key === "Esc") {
          e.preventDefault();
          e.stopPropagation();
          closeModal();
        }
      }}
    >
      <FocusTrap
        focusTrapOptions={{
          initialFocus: () =>
            document.querySelector('#modal [data-modal-action="action2"]') ||
            document.querySelector("#modal button:not([disabled])") ||
            document.querySelector("#modal") ||
            document.body,
          fallbackFocus: () => document.querySelector("#modal") || document.body,
          clickOutsideDeactivates: false,
          escapeDeactivates: false
        }}
      >
        <div
          id="modal"
          className={`
            ${styles.modalContainer}
            shadow-modalShadow dark:shadow-modalDarkShadow bg-white  m-auto flex flex-col outline-none`}
          style={{ maxWidth }}
        >
          {children || (
            <div
              className={`${styles.defaultModal} w-full text-dark  flex flex-col gap-4`}
            >
              <div className="w-full flex">
                <h3 id="modal-title" className="font-bold flex-1">
                  {titleCMSNode ? (
                    <CmsInlineEdit cmsNode={titleCMSNode} preEdit={cmsPreEdit}>
                      {title}
                    </CmsInlineEdit>
                ) : (
                  title
                )}
                </h3>
                {exit ? (
                  <button
                    type="button"
                    className="w-6 h-6 cursor-pointer bg-transparent border-none p-0"
                    aria-label="Close dialog"
                    onClick={() => onModalClose()}
                  >
                    <img alt="exit-icon" src={exitIcon} />
                  </button>
              ) : null}
              </div>

              <p className="text-darkElevationPrimary">
                {descriptionCMSNode ? (
                  <CmsInlineEdit
                    cmsNode={descriptionCMSNode}
                    preEdit={cmsPreEdit}
                  >
                    {description}
                  </CmsInlineEdit>
              ) : (
                <span dangerouslySetInnerHTML={{ __html: description }} />
              )}
              </p>
              <div className=" text-right">
                {action1Label ? (
                  <button
                    onClick={action1}
                    data-modal-action="action1"
                    tabIndex={0}
                    onKeyDown={e => {
                    if (e.key === "Enter") {
                      action1();
                    }
                  }}
                    type="button"
                    className={`
                      bg-transparent text-border ${styles.lightAction}
                    `}
                  >
                    {action1Label}
                  </button>
              ) : null}
                {action2Label ? (
                  <button
                    onClick={action2}
                    data-modal-action="action2"
                    tabIndex={0}
                    onKeyDown={e => {
                    if (e.key === "Enter") {
                      action2();
                    }
                  }}
                    type="button"
                    className={`bg-dark text-white ${styles.lightAction}`}
                  >
                    {action2Label}
                  </button>
              ) : null}
                {action3Label ? (
                  <button
                    onClick={action3}
                    data-modal-action="action3"
                    tabIndex={0}
                    onKeyDown={e => {
                    if (e.key === "Enter") {
                      action3();
                    }
                  }}
                    type="button"
                    className={`bg-dark text-white ${styles.lightAction}`}
                  >
                    {action3Label}
                  </button>
              ) : null}
              </div>
            </div>
          )}
        </div>
      </FocusTrap>
    </div>
  );
};

Modal.propTypes = {
  exit: PropTypes.bool,
  title: PropTypes.string,
  titleCMSNode: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  description: PropTypes.string,
  descriptionCMSNode: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  action1: PropTypes.func,
  action1Label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  action2: PropTypes.func,
  action2Label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  action3: PropTypes.func,
  action3Label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setModalObject: PropTypes.func.isRequired,
  children: PropTypes.element,
  maxWidth: PropTypes.string,
  zIndex: PropTypes.number,
  cmsPreEdit: PropTypes.func,
  ariaLabelledBy: PropTypes.string,
  fullscreenChildren: PropTypes.bool
};

Modal.defaultProps = {
  exit: true,
  title: null,
  titleCMSNode: null,
  description: null,
  descriptionCMSNode: null,
  action1: null,
  action1Label: null,
  action2: null,
  action2Label: null,
  action3: null,
  action3Label: null,
  children: null,
  maxWidth: null,
  zIndex: 99999,
  cmsPreEdit: null,
  ariaLabelledBy: null,
  fullscreenChildren: false
};

export const mapDispatchToProps = dispatch => ({
  setModalObject: value => dispatch(elementsActions.setModalObject(value))
});

export default connect(null, mapDispatchToProps)(Modal);
